import React from "react";
import DedicatedHero from "../components/dedicated/DedicatedHero";
import DedicatedHowItWorks from "../components/dedicated/DedicatedHowItWorks";
import DedicatedOfferings from "../components/dedicated/DedicatedOfferings";
import DedicatedFAQ from "../components/dedicated/DedicatedFAQ";
import DedicatedCTA from "../components/dedicated/DedicatedCTA";

export default function DedicatedPage() {
  return (
    <>
      <DedicatedHero />
      <DedicatedHowItWorks />
      <DedicatedOfferings />
      <DedicatedFAQ />
      <DedicatedCTA />
    </>
  );
}
